import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import MaxWidthContainer from '../MaxWidthContainer';
import Button from '../Button';
import { getHeaderNavLinksForPage } from '../../utility/navLinks/headerNavLinks';
import { Link } from 'react-router-dom';
import LoginModal from '../LoginModal/LoginModal';
import Auth from '../../modules/auth';
import CloseIcon from '../Icons/CloseIcon';
import CaretDownIcon from '../Icons/CaretDownIcon';
import RightArrow from '../Icons/RightArrow';
import './Navbar.scss';
import { useAuthContext } from '../../contexts/AuthContext';
import HamburgerIcon from '../Icons/HamburgerIcon';
import CoursesNav from './partials/CoursesNav';
import Image from '../Image';
import ReferAFriendIcon from '../Icons/ReferAFriendIcon';
import LogoutIcon from '../Icons/LogoutIcon';
import StudentPortalIcon from '../Icons/StudentPortalIcon';
import { Children } from 'react';
import DiscountBanner from '../DiscountBanner';
import { useUserSessionContext } from '../../contexts/UserSessionContext/UserSessionContext';
import { useWindowWidthContext } from '../../contexts/WindowWidthContext';

const Navbar = ({ inPageScrolls, showFullLogo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const {
    withValidReferralCode,
    sessionHomePageLogoLink,
  } = useUserSessionContext();

  const {
    isLoading,
    isLoggedIn,
    user,
    toggleLoginModal,
    logout,
  } = useAuthContext();
  const history = useHistory();
  const { isDesktopView } = useWindowWidthContext();

  const navRef = useRef(null);
  const navLinks = getHeaderNavLinksForPage();

  const className = 'c-Navbar';

  const fullLogo = {
    alt: 'logo',
    mobileImgData: {
      src:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/nalogo-white.svg',
      meta: {
        width: 150,
        height: 16,
      },
    },
  };

  const shortLogo = {
    alt: 'logo',
    mobileImgData: {
      src:
        'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/naShortLogo.svg',
      meta: {
        width: 40,
        height: 18,
      },
    },
  };

  function navbarScrollStyle() {
    if (window.scrollY > 80) {
      navRef.current.style.boxShadow = '0px 3px 28px rgba(0, 0, 0, 0.08)';
    } else {
      navRef.current.style.boxShadow = 'none';
    }
  }

  function toggleMenu() {
    setIsMenuOpen((prev) => !prev);
  }

  const token = Auth.getUserToken();
  const refreshToken = Auth.getRefreshToken();
  const credit = user?.learner?.credits?.totalCredit || 0;
  const formattedCredit = `${credit / 100}USD`;
  const creditItem = `Total Credits: ${formattedCredit}`;
  const ctaItems = [
    {
      icon: <StudentPortalIcon />,
      text: 'Student Portal',
      onClick: () => {
        window.location.href = `https://learn.nas.academy?token=${token}&refreshToken=${refreshToken}`;
      },
    },
    {
      icon: <ReferAFriendIcon />,
      text: 'Refer a friend',
      label: 'NEW',
      onClick: () => {
        history.push('/refer-a-friend');
      },
    },
    { icon: <LogoutIcon />, text: 'Logout', onClick: logout },
  ];

  const renderDesktopDropdownItems = () => {
    const parentClassName = 'c-Navbar';
    const containerClassName = `${parentClassName}__ContentWrapper`;
    const className = `${containerClassName}__AuthOption`;

    const renderCTAItems = () =>
      Children.toArray(
        ctaItems.map(({ icon, text, label, onClick }) => (
          <li onClick={onClick} className={`${className}__dropdown__item`}>
            <div className={`${className}__icon-wrapper`}>{icon}</div>
            <span>{text}</span>
            {label && <span className={`${className}__label`}>{label}</span>}
          </li>
        ))
      );

    return (
      <ul className={`${className}__dropdown__wrapper`}>
        {credit > 0 && (
          <li
            className={`${className}__dropdown__item ${className}__dropdown__item--static`}
          >
            <span>{creditItem}</span>
          </li>
        )}
        {renderCTAItems()}
      </ul>
    );
  };

  const renderMobileDropdownItems = () => {
    const parentClassName = 'c-Navbar';
    const containerClassName = `${parentClassName}__ContentWrapper`;
    const className = `${containerClassName}__AuthOption`;

    const renderCTAItems = () =>
      Children.toArray(
        ctaItems.map(({ icon, text, label, onClick }) => (
          <li onClick={onClick} className={`${className}__auth__option`}>
            <div className={`${className}__icon-wrapper`}>{icon}</div>
            <span>{text}</span>
            {label && <span className={`${className}__label`}>{label}</span>}
          </li>
        ))
      );

    return (
      <ul className={`${className}__auth__options`}>{renderCTAItems()}</ul>
    );
  };

  function renderAuthOptions() {
    if (isLoading) return null;

    const parentClassName = 'c-Navbar';
    const containerClassName = `${parentClassName}__ContentWrapper`;
    const className = `${containerClassName}__AuthOption`;

    const profileImg = user?.learner?.profileImage || '';
    const firstName = user?.learner?.firstName || '';
    const lastName = user?.learner?.lastName || '';

    const formattedMobileCredit = credit ? `- ${formattedCredit} Credits` : '';

    let authOptions = !isLoggedIn ? (
      <div className={`${className}__ContentWrapper__CTA__buttons__wrapper`}>
        <Button
          onClick={toggleLoginModal}
          className={`c-Button ${className}__ContentWrapper__CTA__student-login`}
        >
          LOGIN
        </Button>
      </div>
    ) : (
      <>
        <div className="desktop-only">
          <div className={className}>
            <img
              className={`${className}__profile`}
              src={profileImg}
              alt="profile"
            />
            <p className={`${className}__desc`}>{`${firstName} ${lastName}`}</p>
            <CaretDownIcon />
            <div className={`${className}__dropdown`}>
              {renderDesktopDropdownItems()}
            </div>
          </div>
        </div>
        <div className="mobile-only">
          <div className={`${className}__auth`}>
            <div className={`${className}__auth__name`}>
              <img
                className={`${className}__profile`}
                src={profileImg}
                alt="profile"
              />
              {`${firstName} ${lastName} ${formattedMobileCredit}`}
            </div>
            {renderMobileDropdownItems()}
          </div>
        </div>
      </>
    );
    return authOptions;
  }

  useEffect(() => {
    if (navRef.current) {
      window.addEventListener('scroll', navbarScrollStyle);
    }

    return () => {
      window.removeEventListener('scroll', navbarScrollStyle);
    };
  }, []);

  // Listen to route change
  useEffect(
    () =>
      history.listen(() => {
        setIsMenuOpen(false);
      }),
    [history]
  );

  const getInPageScrollProps = (name) => {
    const onClick = inPageScrolls[name] ? inPageScrolls[name] : null;

    const inPageScrollerClassName = inPageScrolls[name]
      ? `${className}__inPageScroller`
      : '';

    return { onClick, inPageScrollerClassName };
  };

  let navLinksClassName = `${className}__ContentWrapper__Links`;
  if (!isMenuOpen) {
    navLinksClassName = navLinksClassName + `--closed`;
  }

  return (
    <div className={className} ref={navRef}>
      {isDesktopView && withValidReferralCode && <DiscountBanner />}
      <MaxWidthContainer>
        <div className="desktop-only">
          <div className={`${className}__ContentWrapper`}>
            <div className={`${className}__ContentWrapper__Logo`}>
              <Link to={sessionHomePageLogoLink} title="Home">
                {showFullLogo ? (
                  <div className={`${className}__ContentWrapper__Logo--long`}>
                    <Image {...fullLogo} />
                  </div>
                ) : (
                  <div className={`${className}__ContentWrapper__Logo--short`}>
                    <Image {...shortLogo} />
                  </div>
                )}
              </Link>
            </div>
            <ul className={`${className}__ContentWrapper__Links`}>
              {navLinks.map(
                (
                  {
                    link,
                    name,
                    subLinks,
                    isCourseNav,
                    hidden,
                    isLink,
                    theme,
                    external,
                  },
                  index
                ) => {
                  if (hidden) return null;
                  const hasSublinks = !!subLinks?.length;
                  const {
                    onClick,
                    inPageScrollerClassName,
                  } = getInPageScrollProps(name);

                  const courseNavDropdownClassName = [
                    `${className}__ContentWrapper__Links__Wrapper__banner-nav-content`,
                    shortLogo
                      ? ` ${className}__ContentWrapper__Links__Wrapper__banner-nav-content--short`
                      : '',
                  ].join('');

                  return (
                    <li
                      key={index}
                      className={`${className}__ContentWrapper__Links__Wrapper ${
                        theme ? `theme-${theme}` : ''
                      } ${inPageScrollerClassName}`}
                    >
                      {!isLink || onClick ? (
                        <div
                          onClick={onClick}
                          className={`${className}__ContentWrapper__Link--NoLink ${inPageScrollerClassName}`}
                        >
                          {name}
                        </div>
                      ) : external ? (
                        <a href={link} title={name}>
                          {name}
                        </a>
                      ) : (
                        <Link to={link} title={name}>
                          {name}
                        </Link>
                      )}
                      {isCourseNav && !showDropdown && (
                        <div className={courseNavDropdownClassName}>
                          <div
                            className={`${className}__ContentWrapper__Links__Wrapper__banner-nav-content__container`}
                          >
                            <div className="top-arrow" />
                            <CoursesNav
                              onClose={() => setShowDropdown(false)}
                            />
                          </div>
                        </div>
                      )}
                      {hasSublinks ? (
                        <div
                          className={`${className}__ContentWrapper__Links__Wrapper__Content`}
                        >
                          <div className="top-arrow" />
                          <ul
                            className={`${className}__ContentWrapper__Links__Wrapper__sub-links-list`}
                          >
                            {subLinks.map(({ link, external, name }, index) => {
                              return (
                                <li key={index}>
                                  {external ? (
                                    <Link
                                      title={name}
                                      to={{ pathname: link }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {name}
                                    </Link>
                                  ) : (
                                    <Link to={link} title={name}>
                                      {name}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      ) : null}
                    </li>
                  );
                }
              )}
            </ul>
            <div className={`${className}__ContentWrapper__CTA`}>
              {renderAuthOptions()}
            </div>
          </div>
        </div>
        <div className="mobile-only">
          <div className={`${className}__ContentWrapper`}>
            <div className={`${className}__ContentWrapper__Logo`}>
              <Link to={sessionHomePageLogoLink} title="Home">
                {showFullLogo ? (
                  <div className={`${className}__ContentWrapper__Logo--long`}>
                    <Image {...fullLogo} />
                  </div>
                ) : (
                  <div className={`${className}__ContentWrapper__Logo--short`}>
                    <Image {...shortLogo} />
                  </div>
                )}
              </Link>
            </div>
            <div
              className={`${className}__ContentWrapper__Toggle`}
              onClick={toggleMenu}
            >
              {isMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
            </div>
            <div
              className={navLinksClassName}
              style={{ display: isMenuOpen ? 'block' : 'none' }}
            >
              <div className={`${className}__ContentWrapper__Links__Content`}>
                <div className={`${className}__ContentWrapper__CTA`}>
                  {renderAuthOptions()}
                </div>
                {navLinks.map(
                  (
                    {
                      link,
                      name,
                      subLinks,
                      isCourseNav,
                      hidden,
                      theme,
                      external,
                    },
                    index
                  ) => {
                    if (hidden) return null;
                    if (isCourseNav) {
                      return <CoursesNav key={index} />;
                    }
                    const hasSublinks = !!subLinks?.length;
                    const {
                      onClick: scrollHandler,
                      inPageScrollerClassName,
                    } = getInPageScrollProps(name);

                    const onClick = scrollHandler
                      ? () => {
                          scrollHandler();
                          toggleMenu();
                        }
                      : null;

                    return (
                      <li key={index} className={`${className}__Links`}>
                        <div
                          className={`${className}__Links__Container ${
                            theme ? `theme-${theme}` : ''
                          }`}
                        >
                          {onClick ? (
                            <div
                              onClick={onClick}
                              className={`${className}__ContentWrapper__Link--NoLink ${inPageScrollerClassName}`}
                            >
                              {name}
                            </div>
                          ) : external ? (
                            <a href={link} title={name}>
                              {name}
                            </a>
                          ) : (
                            <Link to={link}>{name}</Link>
                          )}
                          {hasSublinks && <RightArrow />}
                        </div>
                        {hasSublinks ? (
                          <>
                            <ul className={`${className}__SubLinks__Wrapper`}>
                              {subLinks.map(
                                ({ link, external, name }, index) => {
                                  return (
                                    <li
                                      key={index}
                                      className={`${className}__SubLinks`}
                                    >
                                      {external ? (
                                        <Link
                                          title={name}
                                          to={{ pathname: link }}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {name}
                                        </Link>
                                      ) : (
                                        <Link to={link} title={name}>
                                          {name}
                                        </Link>
                                      )}
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                            <div className="divider" />
                          </>
                        ) : null}
                      </li>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </MaxWidthContainer>
      {!isDesktopView && withValidReferralCode && <DiscountBanner />}
      <LoginModal />
    </div>
  );
};

Navbar.propTypes = {
  inPageScrolls: PropTypes.object,
  showFullLogo: PropTypes.bool,
};

Navbar.defaultProps = {
  inPageScrolls: {},
  showFullLogo: false,
};

export default Navbar;
